import { workScheduleBetweenItems } from '@omecare/utils';
import { isSameDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { buildPeriodSummaryLabel } from '@/components/forms/slot-period-summary';
import { OfficeDoctorAttendingItem } from '@/hooks/queries/use-get-office';
import { doctorFullnameTitleTrad } from '@/utils/doctor';
import { OpenOfficeAgendaSlotUseForm } from './use-open-office-agenda-slot-form';

export const selectAgendaSlotTypeOptions = [
  {
    id: 'fullvisio',
    label: 'agenda-slot.types.fullvisio',
    value: 'fullvisio',
  },
  {
    id: 'mixed',
    label: 'agenda-slot.types.mixed',
    value: 'mixed',
  },
] as const;

export const useOpenOfficAgendaSlotFormViewModel = ({
  form,
  doctorAttendings,
}: {
  form: OpenOfficeAgendaSlotUseForm;
  doctorAttendings: OfficeDoctorAttendingItem[];
}) => {
  const { t } = useTranslation();

  const selectDoctorAttendingOptions = doctorAttendings.map(
    (doctorAttending) => {
      const doctorTrad = doctorFullnameTitleTrad(doctorAttending);
      return {
        id: doctorAttending.id,
        label: t(doctorTrad.key, doctorTrad.params),
        value: doctorAttending.id,
      };
    },
  );

  const selectPeriodOfTheDayOptions = workScheduleBetweenItems.filter(
    (i) => i.id !== 'none',
  );

  const slotType = form.watch('slotType');
  const periodOfTheDay = form.watch('periodOfTheDay');
  const specificDates = form.watch('specificDates');

  return {
    slotType,
    selectOptions: {
      doctorAttendingOptions: selectDoctorAttendingOptions,
      periodOfTheDayOptions: selectPeriodOfTheDayOptions,
      agendaSlotTypeOptions: selectAgendaSlotTypeOptions,
    },
    specificSlots: {
      selectedDates: specificDates,
      periodSummaryLabel: buildPeriodSummaryLabel({
        periodOfTheDay,
        translate: t,
      }),
    },
    api: {
      removeSelectedDate: (date: Date) => {
        form.setValue(
          'specificDates',
          specificDates.filter((selected) => !isSameDay(selected, date)),
        );
      },
      clearSelectedDates: () => {
        form.setValue('specificDates', []);
      },
    },
  };
};
